import React from "react";

import TarjetaFacturado from "./cards/TarjetaFacturado";
import TarjetaIngresos from "./cards/TarjetaIngresos";
import TarjetaCompras from "./cards/TarjetaCompras";
import TarjetaEgresos from "./cards/TarjetaEgresos";
import TarjetaImpuestos from "./cards/TarjetaImpuestos";
import TarjetaCxP from "./cards/TarjetaCxP";
import TarjetaCxC from "./cards/TarjetaCxC";
import TarjetaNotasCredito from "./cards/TarjetaNotasCredito";
import TarjetaOrdenesCompra from "./cards/TarjetaOrdenesCompra";
import TarjetaCotizaciones from "./cards/TarjetaCotizaciones";

const AppCard = ({
    anio,
    mes,
}) => {
    const styles = {
        cardsContainer: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
            width: '100%',
            padding: 0,
            margin: "0 0 15px",
            rowGap: "10px",
            columnGap: "10px",
        },
        paragraph: {
			fontSize: "16px",
			marginBottom: "7px",
			textTransform: "upperCase",
			textAlign: "center",
		},
        columnStyles: {
			borderRadius: "8px",
			padding: "7px",
			margin: "3px",
			minHeight: "100px",
			background: "white",
            flex: 1,
		},
        columnContainer: {
            padding: "10px",
            lineHeight: 1,
            position: "relative",
        },
        header: {
            borderBottom: "1px solid #ddd",
            paddingBottom: "2px",
            marginBottom: "2px",
        },
        principal: {
            fontSize: "24px",
            fontWeight: "bold",
        },
        subtitulo: {
            margin: "4px 0",
            textTransform: "uppercase",
            fontWeight: "500",
            fontSize: "13px",
            color: "#999"
        },
        infoBlockContainer: {
            maxHeight: "75px",
            overflow: "hidden",
        },
        infoBlock: {
            marginTop: "7px",
            padding: "0 15px",
            width: "100%",
        },
        label: {
            fontSize: "10px",
            textTransform: "uppercase",
            color: "#999",
            marginTop: "3px",
            display: "block"
        },
        hr: {
            margin: "5px 0"
        },
        expandir: {
            textAlign: 'center',
            textTransform: 'uppercase',
            width: "100%",
            fontSize: "11px",
            position: "absolute",
            bottom: 0,
            left: 0,
            color: "#999",
            padding: "55px 7px 10px",
            background: "linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))"
        }
    }

	return (
        <>
            <style>
				{`
                    @import url('https://fonts.googleapis.com/css2?family=Saira+Extra+Condensed:wght@400;700&display=swap');
                    .loader-wrapper {
                        padding: 15px !important;
                        height: 140px;
                    }
                    @media(max-width: 800px) {
                        .dashboard-cards-container {
                            grid-template-columns: 1fr !important;
                        }
                    }
				`}
			</style>
            <div className="dashboard-cards-container" style={styles.cardsContainer}>
                {/*Facturado del mes */}
                <TarjetaFacturado anio={anio} mes={mes} styles={styles} />

                {/* Card Ingresos */}
                <TarjetaIngresos anio={anio} mes={mes} styles={styles} />

                {/* Card Compras */}
                <TarjetaCompras anio={anio} mes={mes} styles={styles} />

                {/* Card egresos */}
                <TarjetaEgresos anio={anio} mes={mes} styles={styles} />

                {/* Itbis */}
                <TarjetaImpuestos anio={anio} mes={mes} styles={styles} />

                {/* CXP */}
                <TarjetaCxP anio={anio} mes={mes} styles={styles} />

                {/* CXC */}
                <TarjetaCxC anio={anio} mes={mes} styles={styles} />

                {/* Notas de Crédito */}
                <TarjetaNotasCredito anio={anio} mes={mes} styles={styles} />

                {/* Ordenes de Compra */}
                <TarjetaOrdenesCompra anio={anio} mes={mes} styles={styles} />

                {/* Cotizaciones */}
                <TarjetaCotizaciones anio={anio} mes={mes} styles={styles} />
            </div>
        </>
	);
};

export default AppCard;
